// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"3991bcd8","232":"1051aa27","237":"adeb38b3","526":"7dc2a6c3","787":"17f52d63"}[chunkId] + ".chunk.js";
};